import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  popover: {
    '> .MuiPopover-paper': {
      backgroundColor: theme.background.b1,
      border: `1px solid ${theme.secondary.s1}`,
      borderRadius: 8,
      boxShadow: 'none',
      left: '50% !important',
      maxWidth: 1000,
      overflow: 'visible',
      padding: 16,
      pointerEvents: 'auto',
      transform: 'translateX(-50%) !important',
      width: '100%',

      '&::after': {
        content: "''",
        position: 'absolute',
        top: -15,
        left: 15,
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: `17px solid ${theme.background.b1}`,
      },

      '&::before': {
        content: "''",
        position: 'absolute',
        top: -17,
        left: 14,
        width: 0,
        height: 0,
        borderLeft: '11px solid transparent',
        borderRight: '11px solid transparent',
        borderBottom: `18px solid ${theme.secondary.s1}`,
      },

      '&::-webkit-scrollbar': {
        width: 8,
      },

      '&::-webkit-scrollbar:horizontal': {
        height: 8,
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.secondary.s2,
        borderRadius: 4,
      },

      '&::-webkit-scrollbar-thumb': {
        background: theme.secondary.s6,
        transition: '0.3s',
        border: `2px solid ${theme.secondary.s6}`,
        borderRadius: 4,

        '&:hover': {
          background: theme.secondary.s6,
        },

        '&:active': {
          background: theme.secondary.s6,
        },
      },
    },
  },
}));

export default useStyles;
